import { render } from "./PickList.vue?vue&type=template&id=4c7ead10&scoped=true"
import script from "./PickList.vue?vue&type=script&lang=js"
export * from "./PickList.vue?vue&type=script&lang=js"

import "./PickList.vue?vue&type=style&index=0&id=4c7ead10&lang=scss&scoped=true"

import exportComponent from "../../../../../SINTEZ/store/webadmin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4c7ead10"]])

export default __exports__